function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-303.000000, -103.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "phone-2",
  transform: "translate(303.000000, 103.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "phone"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-17",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-23"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-23"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
  mask: "url(#mask-17)",
  fill: "#ffffff00",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.000000, -4.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 27,
  height: 27
})))))), /*#__PURE__*/React.createElement("path", {
  d: "M18.0403919,13.6386358 L15.2124779,13.315762 C14.5333332,13.2378269 13.865322,13.4716321 13.3865807,13.950376 L11.338013,15.9989548 C8.18722693,14.3957193 5.60425031,11.8238622 4.00102347,8.66192545 L6.06072462,6.60221307 C6.53946597,6.12346912 6.77326989,5.4554543 6.69533525,4.77630591 L6.37246318,1.9706437 C6.23886094,0.846152096 5.29251176,0 4.15689275,0 L2.23079383,0 C0.972706094,0 -0.0738447639,1.04655654 0.0040898744,2.3046511 C0.594166422,11.8127286 8.19836045,19.4058304 17.6952528,19.9959101 C18.9533405,20.0738452 20,19.0272886 20,17.7691941 L20,15.8430847 C20.0110249,14.7185931 19.1648774,13.7722388 18.0403919,13.6386358 Z",
  id: "path-23",
  fill: "white"
}));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.79cce4ac.svg";
export { ForwardRef as ReactComponent };